// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* html {
  font-family: 'Roboto', sans-serif;
  line-height: 1.4;
}

body {
  margin: 0;
} */

td,
th {
  border: 1px solid lightgray;
}

.db_table_cell {
  border: 0px solid lightgray;
}

.db_table_row {
  border: 0px solid lightgray;
}

/* 
.db_table_row :hover {
  background-color: #f5f5f5;
} */

.open_db_data_button {
  position: absolute;
  top: 50%;
  right: 9px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid #ccc;
  padding: 3px 3px 3px 3px;
  cursor: pointer;
  background-color: white;
  color: gray;
  column-gap: 4px;
  font-size: 13px;
  font-weight: 500;
  width: 'fit-content';
  white-space: nowrap;
}

.open_db_data_button:hover {
  background-color: #f5f5f5;
}

.focusable_cell:focus {
  outline: 1px solid dodgerblue;
  background-color: azure;
}

.drag_db_data_handler {
  display: flex;
  flex-direction: row;
  position: absolute;
  top: 50%;
  right: 3px;
  transform: translateX(-60%);
  transform: translateY(-50%);
  border-radius: 4px;
  padding: 1;
  align-items: center;
  cursor: pointer;
}

.drag_db_data_handler:hover {
  background-color: #f1f1f1;
}

.add_db_data_handler {
  display: flex;
  flex-direction: row;
  position: absolute;
  top: 50%;
  right: 24px;
  transform: translateX(-60%);
  transform: translateY(-50%);
  border-radius: 4px;
  align-items: center;
  cursor: pointer;
}

.add_db_data_handler :hover {
  background-color: #f1f1f1;
}

/* .drag_db_data_handler_outside {
  display: flex;
  flex-direction: row;
  position: absolute;
  top: 50%;
  left: -24px;
  transform: translateX(-60%);
  transform: translateY(-50%);
  border-radius: 4px;
  padding: 1;
  align-items: center;
  cursor: pointer;
  z-index: 99;
}

.drag_db_data_handler_outside:hover {
  background-color: #f1f1f1;
}

.add_db_data_handler_outside {
  display: flex;
  flex-direction: row;
  position: absolute;
  top: 50%;
  left: -48px;
  transform: translateX(-60%);
  transform: translateY(-50%);
  border-radius: 4px;
  align-items: center;
  cursor: pointer;
  z-index: 99;
}

.add_db_data_handler_outside :hover{
  background-color: #f1f1f1;
} */

.db_table_handle_cell {
  border: 0px solid lightgray;
}

.db_table_header {
  color: #666;
  font-weight: 500;
  font-size: 13px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

#container {
  /* overflow-y: auto; */
  height: 100%;
  width: 100%;
  /* max-width: 800px; */
  background-color: white;
  /* display: flex;
  flex-direction: column;
  align-items: center; */
}

.MuiSvgIcon-root {
  font-size: 18px !important;
}

.tippy-box[data-theme~='tomato'] {
  background-color: tomato;
  color: yellow;
}

.slate-Draggable-dragHandle {
  background-color: white;
  border: 0px white;
  cursor: pointer;
}

/* .slate-Draggable {
  max-width: 800px;
  width: -webkit-fill-available;
} */
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: lightgray;
  opacity: 1;
  /* Firefox */
}

/* .slate-p,
.slate-h1,
.slate-h2,
.slate-h3,
.slate-h4,
.slate-h5,
.slate-h6,
.slate-hr,
.slate-blockquote,
.slate-code,
.slate-img,
.slate-pre,
.slate-table,
.slate-ul,
.slate-ol,
.slate-action_item,
.slate-code_block,
.slate-code_line,
.slate-rilmark,
.slate-subpage,
.slate-slides-embed,
.slate-dbviews-embed,
.slate-media_embed {
  max-width: 800px;
  width: -webkit-fill-available;
} */

/* .slate-selectable {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.group {
  max-width: 800px;
  width: -webkit-fill-available;
} */

.slate-SelectionArea {
  max-width: 896px;
  width: -webkit-fill-available;
}

.slate-tag {
  /* display: "inline-block"; */
  padding: 3px 3px 2px;
  border-radius: 4px;
  background-color: aliceblue;
  color: royalblue;
  font-size: 0.9em;
}

.slate-tag:focus {
  box-shadow: 0 0 0 2px #f90;
  outline: 2px solid red;
  background-color: aqua;
}

.slate-th {
  background-color: whitesmoke;
}

blockquote {
  display: block;
  -webkit-margin-before: 0px;
          margin-block-start: 0px;
  -webkit-margin-after: 0px;
          margin-block-end: 0px;
  -webkit-margin-start: 0px;
          margin-inline-start: 0px;
  -webkit-margin-end: 0px;
          margin-inline-end: 0px;
}

.fill-available {
  width: 100%; /* WebKit-based browsers will ignore this. */
  width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
  width: stretch; /* Updated from fill-available per CSS spec change */
}

.full-height {
  height: 100vh;
  height: 100dvb;
}

.highlighted-image {
  border: 1px solid #eee; /* 设置边框颜色 */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5); /* 设置阴影，可以根据需要调整颜色和大小 */
  max-width: 100%;
  width: auto;
  height: auto;
}

.transparent-background {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0);
  /* 半透明黑色背景 */
  transition: background-color 0.3s ease;
  /* 添加过渡效果 */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.transparent-background:hover {
  background-color: rgba(0, 0, 0, 0.1);
  /* 鼠标悬停时变成更加半透明的背景色 */
}`, "",{"version":3,"sources":["webpack://./src/scss/editor.css"],"names":[],"mappings":"AAAA;;;;;;;GAOG;;AAEH;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;GAGG;;AAEH;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAmCG;;AAEH;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB;;wBAEsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;GAGG;AACH;EACE,yCAAyC;EACzC,gBAAgB;EAChB,UAAU;EACV,YAAY;AACd;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;GAyBG;;AAEH;;;;;;;;;GASG;;AAEH;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,0BAAuB;UAAvB,uBAAuB;EACvB,yBAAqB;UAArB,qBAAqB;EACrB,yBAAwB;UAAxB,wBAAwB;EACxB,uBAAsB;UAAtB,sBAAsB;AACxB;;AAEA;EACE,WAAW,EACY,4CAA4C;EACnE,6BAA6B,EAAE,6CAA6C;EAC5E,cAAc,EAAE,oDAAoD;AACtE;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB,EAAE,WAAW;EACnC,yCAAyC,EAAE,uBAAuB;EAClE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,sCAAsC;EACtC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB","sourcesContent":["/* html {\n  font-family: 'Roboto', sans-serif;\n  line-height: 1.4;\n}\n\nbody {\n  margin: 0;\n} */\n\ntd,\nth {\n  border: 1px solid lightgray;\n}\n\n.db_table_cell {\n  border: 0px solid lightgray;\n}\n\n.db_table_row {\n  border: 0px solid lightgray;\n}\n\n/* \n.db_table_row :hover {\n  background-color: #f5f5f5;\n} */\n\n.open_db_data_button {\n  position: absolute;\n  top: 50%;\n  right: 9px;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  padding: 3px 3px 3px 3px;\n  cursor: pointer;\n  background-color: white;\n  color: gray;\n  column-gap: 4px;\n  font-size: 13px;\n  font-weight: 500;\n  width: 'fit-content';\n  white-space: nowrap;\n}\n\n.open_db_data_button:hover {\n  background-color: #f5f5f5;\n}\n\n.focusable_cell:focus {\n  outline: 1px solid dodgerblue;\n  background-color: azure;\n}\n\n.drag_db_data_handler {\n  display: flex;\n  flex-direction: row;\n  position: absolute;\n  top: 50%;\n  right: 3px;\n  transform: translateX(-60%);\n  transform: translateY(-50%);\n  border-radius: 4px;\n  padding: 1;\n  align-items: center;\n  cursor: pointer;\n}\n\n.drag_db_data_handler:hover {\n  background-color: #f1f1f1;\n}\n\n.add_db_data_handler {\n  display: flex;\n  flex-direction: row;\n  position: absolute;\n  top: 50%;\n  right: 24px;\n  transform: translateX(-60%);\n  transform: translateY(-50%);\n  border-radius: 4px;\n  align-items: center;\n  cursor: pointer;\n}\n\n.add_db_data_handler :hover {\n  background-color: #f1f1f1;\n}\n\n/* .drag_db_data_handler_outside {\n  display: flex;\n  flex-direction: row;\n  position: absolute;\n  top: 50%;\n  left: -24px;\n  transform: translateX(-60%);\n  transform: translateY(-50%);\n  border-radius: 4px;\n  padding: 1;\n  align-items: center;\n  cursor: pointer;\n  z-index: 99;\n}\n\n.drag_db_data_handler_outside:hover {\n  background-color: #f1f1f1;\n}\n\n.add_db_data_handler_outside {\n  display: flex;\n  flex-direction: row;\n  position: absolute;\n  top: 50%;\n  left: -48px;\n  transform: translateX(-60%);\n  transform: translateY(-50%);\n  border-radius: 4px;\n  align-items: center;\n  cursor: pointer;\n  z-index: 99;\n}\n\n.add_db_data_handler_outside :hover{\n  background-color: #f1f1f1;\n} */\n\n.db_table_handle_cell {\n  border: 0px solid lightgray;\n}\n\n.db_table_header {\n  color: #666;\n  font-weight: 500;\n  font-size: 13px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n#container {\n  /* overflow-y: auto; */\n  height: 100%;\n  width: 100%;\n  /* max-width: 800px; */\n  background-color: white;\n  /* display: flex;\n  flex-direction: column;\n  align-items: center; */\n}\n\n.MuiSvgIcon-root {\n  font-size: 18px !important;\n}\n\n.tippy-box[data-theme~='tomato'] {\n  background-color: tomato;\n  color: yellow;\n}\n\n.slate-Draggable-dragHandle {\n  background-color: white;\n  border: 0px white;\n  cursor: pointer;\n}\n\n/* .slate-Draggable {\n  max-width: 800px;\n  width: -webkit-fill-available;\n} */\n::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  color: lightgray;\n  opacity: 1;\n  /* Firefox */\n}\n\n/* .slate-p,\n.slate-h1,\n.slate-h2,\n.slate-h3,\n.slate-h4,\n.slate-h5,\n.slate-h6,\n.slate-hr,\n.slate-blockquote,\n.slate-code,\n.slate-img,\n.slate-pre,\n.slate-table,\n.slate-ul,\n.slate-ol,\n.slate-action_item,\n.slate-code_block,\n.slate-code_line,\n.slate-rilmark,\n.slate-subpage,\n.slate-slides-embed,\n.slate-dbviews-embed,\n.slate-media_embed {\n  max-width: 800px;\n  width: -webkit-fill-available;\n} */\n\n/* .slate-selectable {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n\n.group {\n  max-width: 800px;\n  width: -webkit-fill-available;\n} */\n\n.slate-SelectionArea {\n  max-width: 896px;\n  width: -webkit-fill-available;\n}\n\n.slate-tag {\n  /* display: \"inline-block\"; */\n  padding: 3px 3px 2px;\n  border-radius: 4px;\n  background-color: aliceblue;\n  color: royalblue;\n  font-size: 0.9em;\n}\n\n.slate-tag:focus {\n  box-shadow: 0 0 0 2px #f90;\n  outline: 2px solid red;\n  background-color: aqua;\n}\n\n.slate-th {\n  background-color: whitesmoke;\n}\n\nblockquote {\n  display: block;\n  margin-block-start: 0px;\n  margin-block-end: 0px;\n  margin-inline-start: 0px;\n  margin-inline-end: 0px;\n}\n\n.fill-available {\n  width: 100%;\n  width: -moz-available; /* WebKit-based browsers will ignore this. */\n  width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */\n  width: stretch; /* Updated from fill-available per CSS spec change */\n}\n\n.full-height {\n  height: 100vh;\n  height: 100dvb;\n}\n\n.highlighted-image {\n  border: 1px solid #eee; /* 设置边框颜色 */\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5); /* 设置阴影，可以根据需要调整颜色和大小 */\n  max-width: 100%;\n  width: auto;\n  height: auto;\n}\n\n.transparent-background {\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, 0);\n  /* 半透明黑色背景 */\n  transition: background-color 0.3s ease;\n  /* 添加过渡效果 */\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.transparent-background:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n  /* 鼠标悬停时变成更加半透明的背景色 */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
